import { useState } from "react";
import { Container, Input, Button } from "./style";
import { FaSearch, FaSpinner } from "react-icons/fa";

/** Main Component
 * @param {string?} type - The type of the input, optional
 * @param {string?} value - The value of the input, optional
 * @param {string?} placeholder - The placeholder of the input, optional
 * @param {boolean?} isLoading - The loading state of the button, optional
 * @param {function?} onChange - The function to change the value of the input, optional
 * @param {function} onSubmit - The function to submit the value
 */

const InputSearch = ({
	type = "text",
	value,
	placeholder,
	isLoading,
	onChange,
	onSubmit = () => {},
	...props
}) => {
	const [inputValue, setInputValue] = useState(value ?? "");

	function onChangeValue(event) {
		if (onChange) {
			onChange(event.target.value);
		}
		setInputValue(event.target.value);
	}

	function onKeyDown(event) {
		if (event.key === "Enter") {
			onSubmit(event.target.value);
		}
	}

	return (
		<Container>
			<Input
				type={type ?? "text"}
				placeholder={placeholder}
				value={value ?? inputValue}
				onChange={onChangeValue}
				onKeyDown={onKeyDown}
				disabled={isLoading}
				{...props}
			/>

			<Button
				type="button"
				isLoading={isLoading}
				disabled={isLoading}
				onClick={() => onSubmit(inputValue)}
			>
				{isLoading ? <FaSpinner color={"#fff"} /> : <FaSearch color={"#fff"} />}
			</Button>
		</Container>
	);
};

export { InputSearch };
